import { create } from 'zustand';
import { Configuration } from '../../generated-client/runtime';

const apiUrl = import.meta.env.VITE_COMPASS_PRO_API as string;
const subscriptionKey = import.meta.env.VITE_SUBSCRIPTION_KEY as string;

type ApiState = {
  token: string | null;
  apiConfig: Configuration;

  setToken: (token: string | null) => void;
};

function makeConfig(token: string | null, basePath: string): Configuration {
  return new Configuration({
    basePath,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      'Ocp-Apim-Subscription-Key': subscriptionKey,
    },
  });
}

export const useApiStore = create<ApiState>((set) => {
  const initialToken: string | null = null;

  const trimmedApiURL = apiUrl.replace(/\/api\/$/, '');

  // TODO: remove the /api/ from the env vars

  return {
    token: initialToken,
    apiConfig: makeConfig(initialToken, trimmedApiURL),
    setToken: (token) =>
      set({
        token,
        apiConfig: makeConfig(token, trimmedApiURL),
      }),
  };
});
